import React from "react";

import { Icon } from "Components/atoms/Icon";
import { Typography } from "Components/atoms/Typography";

import { FooterButton, FooterContainer } from "./styles";
import { FlightDetailsFooterProps } from "./types";

/**
 * Componente FlightDetailsFooter
 *
 * Exibe os botões de ação para fechar os detalhes do voo ou navegar para os vendedores.
 *
 * @param {Function} onClose - Callback para fechar os detalhes do voo.
 * @param {Function} onNavigate - Callback para navegar até os vendedores.
 */
export const FlightDetailsFooter: React.FC<FlightDetailsFooterProps> = ({
  onClose,
  onNavigate,
}) => (
  <FooterContainer>
    <FooterButton onClick={onClose}>
      <Typography variant="caption" weight="bold" color="red" uppercase>
        Fechar
      </Typography>
      <Icon library="md" name="MdClose" size="large" color="red" />
    </FooterButton>

    <FooterButton primary onClick={onNavigate}>
      <Typography variant="caption" weight="bold" color="black" uppercase>
        Onde Comprar
      </Typography>
      <Icon name="MdKeyboardArrowUp" size="large" color="black" library="md" />
    </FooterButton>
  </FooterContainer>
);
